(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-related-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Helper para materializar o slider (scroll por item)
  function mountSlider(root){
    const viewport = root.querySelector('[data-relu-viewport]');
    const track = root.querySelector('[data-relu-track]');
    const prev = root.querySelector('[data-relu-prev]');
    const next = root.querySelector('[data-relu-next]');
    if(!viewport || !track) return;

    const gap = 16;
    function itemWidth(){
      const first = track.querySelector('.relu-item');
      return first ? first.getBoundingClientRect().width + gap : 0;
    }
    function scrollByDir(dir){
      viewport.scrollBy({ left: dir * itemWidth(), behavior: 'smooth' });
    }
    prev?.addEventListener('click', ()=>scrollByDir(-1));
    next?.addEventListener('click', ()=>scrollByDir(1));

    // Comprar (usa seu drawer global)
    root.querySelectorAll('.btn-add-to-cart').forEach(btn=>{
      btn.addEventListener('click', async ()=>{
        const id = btn.getAttribute('data-variant-id');
        try{
          const res = await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id, quantity: 1 })
          });
          if(res.ok){
            if(window.openCartDrawer) window.openCartDrawer();
            if(window.updateCartIconBubble) window.updateCartIconBubble();
          }
        }catch(e){ console.error(e); }
      });
    });
  }

  // 1) Se já vier renderizado pelo servidor (recommendations.performed)
  document.querySelectorAll('[data-rel-unified-section]').forEach(sec=>{
    sec.querySelectorAll('[data-relu-wrap]').forEach(mountSlider);
  });

  // 2) Fallback: buscar via endpoint nativo
  document.querySelectorAll('[data-product-recommendations]').forEach(async el=>{
    const pid = el.getAttribute('data-product-id');
    const sid = el.getAttribute('data-section-id');
    const limit = el.getAttribute('data-limit') || 15;
    const url = `/recommendations/products?section_id=${sid}&product_id=${pid}&limit=${limit}`;
    const res = await fetch(url);
    if(!res.ok) return;
    const html = await res.text();

    // O HTML retornado já executa a mesma seção com "recommendations" populados.
    // Substitui o placeholder pelo trecho de slider presente no HTML.
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const wrap = tmp.querySelector('[data-relu-wrap]');
    if(wrap){
      el.outerHTML = wrap.outerHTML;
      // Montar slider nos elementos recém-inseridos
      const inserted = document.querySelectorAll('[data-relu-wrap]');
      inserted.forEach(mountSlider);
    }else{
      // Fallback: se não veio nada, remove placeholder
      el.remove();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-home"] && !Shopify.designMode) return;
  try {
    
// JS da vitrine da HOME (aplicado sempre)
window.initHomeVitrineCore = function(root){
  const viewport = root.querySelector('.hv-viewport');
  const track = root.querySelector('.hv-track');
  const prev = root.querySelector('.hv-prev');
  const next = root.querySelector('.hv-next');
  if(!viewport || !track) return;

  const gap = 16;
  function itemW(){
    const f = track.querySelector('.hv-item');
    return f ? f.getBoundingClientRect().width + gap : 0;
  }
  function go(d){ viewport.scrollBy({ left: d * itemW(), behavior: 'smooth' }); }
  prev?.addEventListener('click', ()=>go(-1));
  next?.addEventListener('click', ()=>go(1));

  // Add to cart padrão do tema
  root.querySelectorAll('.btn-add-to-cart').forEach(btn=>{
    btn.addEventListener('click', async ()=>{
      const id = btn.getAttribute('data-variant-id');
      try{
        const res = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ id, quantity: 1 })});
        if(res.ok){
          if(window.openCartDrawer) window.openCartDrawer();
          if(window.updateCartIconBubble) window.updateCartIconBubble();
        }
      }catch(e){ console.error(e); }
    });
  });
};

// Auto-init no render server-side
document.querySelectorAll('[data-home-vitrine-core]').forEach(window.initHomeVitrineCore);

// Fallback: busca recomendações e injeta APENAS o markup (CSS/JS já estão nesta seção)
document.querySelectorAll('[data-rel-home] [data-rec]').forEach(async el=>{
  const pid = el.getAttribute('data-product-id');
  const sid = el.getAttribute('data-section-id');
  const limit = el.getAttribute('data-limit') || 15;
  const url = `/recommendations/products?section_id=${sid}&product_id=${pid}&limit=${limit}`;
  const res = await fetch(url);
  if(!res.ok) return;
  const html = await res.text();
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const core = tmp.querySelector('[data-home-vitrine-core]');
  if(core){
    el.outerHTML = core.outerHTML;     // só markup
    document.querySelectorAll('[data-home-vitrine-core]').forEach(window.initHomeVitrineCore);
  }else{
    el.remove();
  }
});

  } catch(e) { console.error(e); }
})();
})();
